import { List, Map, fromJS } from 'immutable';

export function request(state, { id, name }) {
    let list = state.get('list') || Map(),
        customer = (list.get(id) || Map())
                        .set('state', 'IN_PROGRESS')
                        .set('errors', void 0);

    if (name) {
        customer.set('name', name);
    }

    state = state.set(
        'list',
        list.set(id, customer)
    );

    let opened = state.get('opened') || List();

    if (!opened.contains(id)) {
        opened = opened.push(id);
    }

    state = state.set('opened', opened);

    return state;
}

export function error(state, { id, errors }) {
    let list = state.get('list') || Map(),
        customer = (list.get(id) || Map())
                        .set('state', 'ERROR')
                        .set('errors', fromJS(errors));

    state = state.set(
        'list',
        list.set(id, customer)
    );

    return state;
}

export function finish(state, { id, customer }) {
    let firstName = customer.firstName.hasOwnProperty("value") ? customer.firstName.value : customer.firstName;
    let surname = customer.surname.hasOwnProperty("value") ? customer.surname.value : customer.surname;
    let list = state.get('list') || Map(),
        customerEl = (list.get(id) || Map())
                        .set('name', firstName + ' ' + surname)
                        .set('data', fromJS(customer))
                        .set('state', 'FINISHED')
                        .set('errors', void 0);

    state = state.set(
        'list',
        list.set(id, customerEl)
    );

    return state;
}

export function clear(state) {
    return state.set('opened', List());
}
